import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
export default {
  name: "user-manager",
  data: function data() {
    return {
      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        bz: "",
        tz: ""
      },
      dialogVisible: false // 弹窗状态
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getData: function getData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getCapitalRatio();
            case 1:
              res = _context2.v;
              _this2.tableData = [];
              _this2.tableData.push({
                bz: res.data.bz,
                tz: res.data.tz
              });
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(!_this3.form.bz || !_this3.form.tz)) {
                _context3.n = 1;
                break;
              }
              _this3.$message.error("请填写完整信息");
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return _this3.$api.updateCapitalRatio(_this3.form);
            case 2:
              _this3.dialogVisible = false;
              _this3.getData();
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    }
  }
};